module.exports = __webpack_public_path__ + "static/media/blue.65ab4cb2.png";